import request from '@/utils/request'
import URL from './urlTranslator'

// 获取海关商品编码
export function getCustomsCommodityCodeList(params) {
  return request({
    url: URL.mdm.customsCommodityCode.customsCommodityCode,
    method: 'get',
    params
  })
}

// 平台新增基础港口
export function addCustomsCommodityCode(data) {
  return request({
    url: URL.mdm.customsCommodityCode.customsCommodityCode,
    method: 'post',
    data
  })
}

// 编辑空运港口
export function updateCustomsCommodityCode(data) {
  return request({
    url: URL.mdm.customsCommodityCode.customsCommodityCode,
    method: 'put',
    data
  })
}

// 批量删除海关商品编码
export function batchDelCustomsCommodityCode(uuidList) {
  const data = [...uuidList]
  return request({
    url: URL.mdm.customsCommodityCode.customsCommodityCode,
    method: 'delete',
    data
  })
}
